<template>
  <div class="unOhter-content">
    <div>
      <ElementSelect
        :options="userSelectsOptions"
        @selectValue="(e) =>changeProd(e)"
        :defaultValue="pid"
      />
    </div>
    <div class="tab-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane lazy :label="$t('product.flow')" name="first">
          <StaticData
            v-if="activeName === 'first'"
            mytype="flows"
            name="product"
            :id="this.pid.toString()"
          />
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('product.statuscode')" name="second">
          <StaticData
            v-if="activeName === 'second'"
            mytype="codes"
            name="product"
            :id="this.pid.toString()"
          />
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('product.hitrate')" name="third">
          <StaticData
            v-if="activeName === 'third'"
            mytype="hits"
            name="product"
            :id="this.pid.toString()"
          />
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('product.defense')" name="four">
          <StaticData
            v-if="activeName === 'four'"
            mytype="wafs"
            name="product"
            :id="this.pid.toString()"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import StaticData from "@/views/products/StaticData.vue";
import { productDetail, productList } from "@/service/requestRes";
export default {
  components: {
    StaticData,
  },
  data() {
    return {
      pid: "",
      product: { name: null },
      activeName: "first",
      selectProdId: "",
      userSelectsOptions: [],
    };
  },
  computed: {
    items() {
      return [
        {
          label: this.$t("product.productlist"),
          click: () => {
            this.$emit("closePage");
          },
        },
        {
          label: this.$t("product.Statistics"),
        },
      ];
    },
  },
  mounted() {
    // this.pid = this.$route.params.pid;
    this.getAllProductList({ page: 1 });
  },
  methods: {
    getAllProductList({ page }) {
      productList({
        page,
        limit: 100,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.userSelectsOptions =
            list.data &&
            list.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });

          const first = this.userSelectsOptions[0];
          this.pid = first.value;
          this.getProductDetail();
        }
      });
    },
    changeProd(e) {
        this.pid = e;
        this.getProductDetail();
    },
    getProductDetail() {
      productDetail(this.pid).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.product = data;
          window.console.debug(data);
        } else {
          //   this.$message({
          //     message: msg,
          //     type: "error",
          //   });
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.setting {
  background-color: white;
  padding: 24px;
}
.tab-content {
  ::v-deep .el-tabs__item.is-active {
    color: #2664ff;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #2664ff;
  }
}
::v-deep .el-tabs__nav-wrap::after {
  width: 960px;
}
.unOhter-content {
    min-height: 900px;
    padding-top: 24px;
}
::v-deep .static-liul .echarts[data-v-79de3939] {
  width: 80%;
  height: 400px;
}
</style>
